import React from "react";
import { createRoot } from "react-dom/client";
import { AuthGate } from "./AuthGate.tsx";
import { ErrorBoundary } from "./ErrorBoundary.tsx";
import { ThemeProvider } from "./theme.tsx";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary fallbackTitle="应用遇到未捕获的渲染异常">
      <ThemeProvider>
        <AuthGate />
      </ThemeProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
